import * as React from "react";
import { DecorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 3;
export const CardComparisonBenefitsSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [benefitsIcon, benefitsTitle, benefitsDescription] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <UitkSpacing
      padding={{
        extra_large: { inlinestart: "twelve" },
        large: { inlinestart: "twelve" },
        medium: { inline: "twelve" },
      }}
      margin={{
        extra_large: { inlinestart: "six" },
        large: { inlinestart: "six" },
        medium: { inline: "twelve" },
      }}
    >
      <UitkLayoutFlex space="three">
        <UitkLayoutFlexItem>
          <div>{benefitsIcon}</div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <div>
            <UitkText size={400} weight="bold">
              {benefitsTitle}
            </UitkText>
            <UitkText size={200}>{benefitsDescription}</UitkText>
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default CardComparisonBenefitsSectionEditorial;
